import { render, staticRenderFns } from "./open-carousel.vue?vue&type=template&id=52ed068f&scoped=true&"
import script from "./open-carousel.vue?vue&type=script&lang=ts&"
export * from "./open-carousel.vue?vue&type=script&lang=ts&"
import style0 from "./open-carousel.vue?vue&type=style&index=0&id=52ed068f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed068f",
  null
  
)

export default component.exports